import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Content, Resource, DocumentRequest } from '../../shared/models/content';
import { AdminService } from '../admin.service';
import { DatePipe } from '@angular/common';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ConfirmModalComponent } from '../../shared/components/confirm-modal/confirm-modal.component';
import { TCCPCommonService } from '../../shared/services/tccp-common.service';
import * as _ from 'lodash';
import { environment } from '../../../environments/environment';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-manage-resources',
  templateUrl: './manage-resources.component.html',
  styleUrls: ['./manage-resources.component.scss']
})
export class ManageResourcesComponent implements OnInit {

  public displayedColumns: string[] = [];
  public resourceDataSource = new MatTableDataSource([]);
  public contents: Content[];
  public resourceGroup: any[];
  public hasPermission = false;

  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  constructor(
    private dialog: MatDialog, public commonService: TCCPCommonService, private adminService: AdminService, private datePipe: DatePipe) {
    this.displayedColumns = ['resources.resourceName', 'resources.resourceGroup', 'featureType',
      'uploadedTime', 'uploadedBy', 'edit', 'delete'];
  }

  ngOnInit() {
    this.getAllContents();
  }

  getAllContents() {
    this.adminService.getAllResources().subscribe((response: any) => {
      if (response) {
        response['sortUploadedTime'] = response.uploadedTime;
        let sortedContents = [];

        sortedContents = response.sort((obj1, obj2) =>
          obj1.resources.resourceName > obj2.resources.resourceName ? 1 : -1);

        this.resourceGroup = response.map(x => x.resources.resourceGroup);
        this.resourceGroup = this.resourceGroup.filter((n, i) => this.resourceGroup.indexOf(n) === i).sort((a, b) => a > b ? 1 : -1);

        this.resourceDataSource.data = sortedContents;
        setTimeout(() => {
          this.resourceDataSource.sortingDataAccessor = (item, property) => {
            switch (property) {
              case 'resources.resourceName': return item.resources.resourceName;
              case 'resources.resourceGroup': return item.resources.resourceGroup;
              case 'uploadedTime': return item.sortUploadedTime;
              default: return item[property];
            }
          };

          this.resourceDataSource.sort = this.sort;
          this.resourceDataSource.paginator = this.paginator;
        });
        this.resourceDataSource.filterPredicate = (data: any, filter) => {
          const dataStr = JSON.stringify(data).toLowerCase();
          return dataStr.indexOf(filter) !== -1;
        };
      }
    });
  }

  applyFilter(filterValue: string) {
    this.resourceDataSource.filter = filterValue.trim().toLowerCase();
  }

  deleteResource(content: Content) {
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      width: '350px',
      data: 'Are you sure you want to delete the Resource?',
      position: { top: '100px' }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.deleteContent(content.contentId);
      }
    });
  }

  deleteContent(id: string) {
    this.adminService.deleteContentById(id).subscribe(data => {
      this.getAllContents();
    });
  }

  addResources() {
    const dialogRef = this.dialog.open(AddResourcesDialogComponent, {
      width: '500px',
      data: { resourceGroup: this.resourceGroup, content: <Content> { resources: <Resource> {} } }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getAllContents();
      }
    });
  }

  editResource(contentObj: Content) {
    const dialogRef = this.dialog.open(AddResourcesDialogComponent, {
      width: '500px',
      data: { resourceGroup: this.resourceGroup, content: contentObj },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getAllContents();
      }
    });
  }

}

@Component({
  selector: 'app-add-resources-dialog-component',
  templateUrl: './add-resources-dialog.componet.html',
  styleUrls: ['../admin.component.scss', './manage-resources.component.scss']

})
export class AddResourcesDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ManageResourcesComponent>, private adminService: AdminService,
    private authService: MsalService, @Inject(MAT_DIALOG_DATA) public data: any) { }
  public resource: Resource = <Resource> {};
  public division: string;
  public featureType: string;
  public isSubmit = false;
  public content: Content = <Content> { resources: <Resource> {} };
  public Groups = [];
  public theme: string = null;

  ngOnInit() {
    this.theme = environment.applicationName + '-' + this.adminService.selectedApplication;
    this.division = this.adminService.selectedApplication.toUpperCase();
    if (this.data) {
      this.content = JSON.parse(JSON.stringify(this.data.content));
      this.Groups = this.data.resourceGroup;
    }
  }

  close(): void {
    this.dialogRef.close();
  }

  uploadFiles() {
    const element: HTMLElement = document.getElementsByClassName('addResourceUploader')[0] as HTMLElement;
    element.click();
  }

  onFileChange(files: FileList) {
    const ext = files[0].name.split('.').pop();
    const filename = files[0].name.replace('.' + ext, new Date().toISOString() + '.' + ext);
    if (files[0].name !== '') {
      let fileRequestBody = new DocumentRequest();
      fileRequestBody.source = this.adminService.selectedApplication;
      fileRequestBody.contentType = files[0].type;
      fileRequestBody.fileName = filename;
      fileRequestBody.contentBase64 = null;
      this.adminService.uploadImage(fileRequestBody).subscribe((response: any) => {
        if (response) {
          this.uploadtoS3(files[0], response.url, files[0].type, response.path);
        }
      });
    }
  }

  uploadtoS3(fileRequest: File, response: string, type: string, path) {
    this.adminService.uploadtoS3(fileRequest, response, type).subscribe((response: any) => {
      this.content.resources.resourceUrl = path;
    });
  }

  onCancel() {
    this.dialogRef.close();
  }
  onSelect() {
    this.isSubmit = true;
    if (this.content.resources.resourceName && this.content.resources.resourceGroup &&
      this.content.resources.resourceUrl && this.content.featureType) {
      this.content.division = this.adminService.selectedApplication;
      this.content.contentType = 'resource';
      this.content.uploadedTime = new Date(new Date().toUTCString());
      this.content.uploadedBy = this.authService.instance.getActiveAccount().username;
      if (!this.content.contentId) {
        this.adminService.insertdocument(this.content).subscribe((response: any) => {
          if (response) {
            this.dialogRef.close({ event: 'save' });
            //  this.getAllContents();
          }
        });
      } else {
        this.adminService.updateSupportContent(this.content).subscribe((response: any) => {
          if (response) {
            this.dialogRef.close({ event: 'save' });
            //  this.getAllContents();
          }
        });
      }
    }
  }
}
